<template>
    <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div
                class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
            >
                <div
                    class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4"
                    @focusout="expand = false"
                >
                    <div class="w-full overflow:auto sm:items-start">
                        <h3 class="pb-2 mb-4 font-medium leading-6 text-gray-700 border-b border-gray-200 text-md" id="modal-headline">
                            Add {{ resource.name }} to projects
                        </h3>
                        <div
                            v-if="projects.length > 0"
                            :class="expand ? 'h-60 max-h-100' : ''"
                            @click="changeSize"
                        >
                            <multiselect
                                @input="changeSize"
                                @select="changeSize"
                                v-model="assigned"
                                track-by="name"
                                label="name"
                                :multiple="true"
                                :close-on-select="false"
                                placeholder="Select projects"
                                :options="unassigned"
                                :searchable="false"
                                :limit="5"
                                open-direction="bottom"
                                class="text-gray-700 border border-gray-300 rounded-md"
                            >
                            </multiselect>
                        </div>
                        <div
                            class="flex flex-col mt-3"
                        >
                            <p
                                v-if="!projects.length"
                                class="mb-4 text-sm italic text-gray-600"
                            >
                                You have no {{ resource.model_type_name }} projects yet.
                            </p>
                            <p
                                v-else
                                class="mb-1 italic">~ or ~
                            </p>
                            <a
                                :href="createProjectRoute"
                                class="px-4 py-2 text-base font-medium text-gray-600 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:text-sm"
                            >
                                {{ addProjectLabel }}
                            </a>
                        </div>
                    </div>
                </div>
                <div>
                    <p
                        v-show="success"
                        class="pl-1 text-center text-gray-800 bg-green-400 border-green-700 rounded opacity-50"
                    >{{ resource.model_type_name }} saved to projects.</p>
                </div>
                <div class="flex justify-between px-4 py-3 bg-gray-200 sm:px-6">
                        <button
                            @click="hideModal"
                            type="button"
                            class="px-4 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            v-if="assigned.length"
                            @click="addToProject"
                            type="button"
                            class="px-4 py-2 text-base font-medium text-white bg-green-500 border border-transparent rounded-md shadow-sm hover:bg-green-600 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                        >
                            Save
                        </button>
                </div>
            </div>
        </div>
    </div>

</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'AddToProject',
    components: {Multiselect},
    props: {
        resource: {
            type: [Array, Object],
            required: true,
        },
    },
    data () {
        return {
            projects: [],
            unassigned: [],
            assigned: [],
            expand: false,
            success: false,
        };
    },
    computed: {
        filteredById: function () {
            return this.assigned.map(project => project.id);
        },
        addProjectLabel () {
            if (this.projects.length) {
                return `Create a new ${ this.resource.model_type_name } project`;
            }
            return `Create your first ${ this.resource.model_type_name } project`;
        },
        createProjectRoute() {
            return this.route('projects.create', {model_type: this.resource.model_type, model_id: this.resource.id});
        },
    },
    methods: {
        hideModal: function () {
            OSPEvent.$emit('close-project-add-modal');
        },
        changeSize () {
            this.expand = true;
        },
        getProjectByResource() {
            const params = {
                model_type: this.resource.model_type,
                model_id: this.resource.id,
            };
            const route = this.route('projects.list-by-resource', params);
            axios.get(route).then(res => {
                this.projects = res.data.assigned.concat(res.data.unassigned);
                this.assigned = res.data.assigned;
                this.unassigned = res.data.unassigned;
            })
            .catch(error => {
                console.log(error);
            });
        },
        addToProject() {
            axios.get(this.route('projects.resource.add', {
                model_type: this.resource.model_type,
                model_id: this.resource.id,
                projects: this.filteredById,
            }))
                .then(res => {
                    this.success = true;
                    setTimeout(() => {
                        this.success = false;
                    }, 3000);
                    this.hideModal();
                })
                .catch(error => {
                    console.log(error.error);
                });
        },
    },
    mounted() {
        this.getProjectByResource();
    },
};
</script>

<style scoped>
#journal-scroll::-webkit-scrollbar {
    width: 4px;
    cursor: pointer;
}

#journal-scroll::-webkit-scrollbar-track {
    background-color: rgba(229, 231, 235, var(--bg-opacity));
    cursor: pointer;
}

#journal-scroll::-webkit-scrollbar-thumb {
    cursor: pointer;
    background-color: #a0aec0;
}
</style>
